const uz = {
    meta: {
        title: "Internet-do'kon uchun qonuniy talablar 2026 — ro'yxat",
        description:
            "Elektron tijorat reyestri, ommaviy oferta, qaytarish qoidalari, chek va ESF. 2026-yilda internet-do'kondan nima talab qilinadi va bu qanchaga tushadi.",
        keywords: [
            "internet do'kon qonuniy talablar O'zbekiston",
            "elektron tijorat subyektlari reyestri",
            "onlayn do'kon ochish uchun nima kerak",
            "ommaviy oferta namunasi sayt",
            "tovarni qaytarish qoidalari onlayn",
        ],
    },
    h1: "Internet-do'kon 2026: reyestr, oferta va qaytarish qoidalari bo'yicha tekshiruv ro'yxati",
    lead:
        "«Sayt qildim, sotaveraman» davri tugadi. 2026-yilda onlayn savdo ro'yxatdan o'tishni, saytdagi aniq sahifalarni va chek bo'yicha yangi talablarni nazarda tutadi. Quyida — tekshiruv ro'yxati va uning narxi.",
    category: "Elektron tijorat",
    readingTime: "9 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Bu maqola yuridik xulosa emas. Biz saytlarni quramiz va qaysi bloklar loyihaga boshidan kiritilishi kerakligini ko'rsatamiz. Yakuniy matnlarni yuristingiz tasdiqlashi kerak — buni loyiha boshida ochiq aytamiz.",
        },

        { type: "h2", text: "2026-yilda nima o'zgardi?" },
        {
            type: "p",
            text:
                "Elektron savdoni takomillashtirishga qaratilgan qonun loyihasi 2026-yil 10-fevralda Qonunchilik palatasi tomonidan qabul qilindi va 18-mayda Senat tomonidan ma'qullandi. Asosiy yangilik shunda: elektron tijorat subyektlari Elektron savdo subyektlari reyestrida ro'yxatdan o'tishi shart qilib belgilandi.",
        },
        {
            type: "p",
            text:
                "Bu tasodifiy qaror emas. Elektron savdo platformalari soni bir yil ichida 36 tadan 115 taga chiqdi — 3,2 barobar o'sish. Bozor kattalashgan sari nazorat ham tizimlashadi: davlat kimning nima sotayotganini ko'rishni xohlaydi.",
        },
        {
            type: "p",
            text:
                "Baza esa o'z joyida qoladi — «Elektron tijorat to'g'risida»gi Qonun. Unga muvofiq onlayn sotuvchi yuridik shaxs, yakka tartibdagi tadbirkor yoki o'zini o'zi band qilgan shaxs bo'lishi kerak. 2026-yilgi o'zgarishlar bu talabni bekor qilmaydi, ustiga ro'yxatdan o'tish majburiyatini qo'yadi.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Reyestrdan o'tish nimani anglatadi?" },
        {
            type: "p",
            text:
                "Reyestr — elektron savdo bilan shug'ullanuvchi subyektlarning rasmiy ro'yxati. Undan o'tish bir martalik ma'muriy harakat, lekin u saytingizga to'g'ridan-to'g'ri ta'sir qiladi.",
        },
        {
            type: "list",
            items: [
                "Ariza berish uchun biznes allaqachon rasmiylashtirilgan bo'lishi kerak: ro'yxatdan o'tganlik guvohnomasi, STIR, bank hisob raqami.",
                "Faoliyat turi savdoga mos bo'lishi shart. Nomuvofiqlik boshqa jarayonlarni ham to'xtatadi.",
                "Sayt ishlayotgan va to'ldirilgan bo'lishi kerak — bo'sh sahifalar bilan ariza berilmaydi.",
                "Ma'lumotlar o'zgarganda (manzil, rekvizit, domen) ularni yangilab borish kerak.",
                "Reyestrdagi ma'lumot ochiq bo'ladi — xaridor sizni tekshira oladi, bu ishonch signali ham.",
            ],
        },
        {
            type: "p",
            text:
                "Amaliy maslahat: reyestr arizasini to'lov tizimi arizasi bilan bir vaqtda tayyorlang. Ikkalasi uchun ham deyarli bir xil hujjatlar to'plami kerak bo'ladi, shuning uchun ularni alohida yig'ish vaqtni ikki barobar ko'p oladi.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Saytda qanday bloklar bo'lishi kerak?" },
        {
            type: "p",
            text:
                "Quyidagi ro'yxat bo'yicha o'z saytingizni hoziroq tekshirib chiqing. Har bir band alohida sahifa yoki aniq ko'rinadigan blok bo'lishi kerak — «kerak bo'lsa aytamiz» varianti ishlamaydi.",
        },
        {
            type: "list",
            items: [
                "To'liq rekvizitlar: tashkilot nomi, STIR, yuridik manzil, telefon va elektron pochta. Odatda futerda joylashtiriladi.",
                "Ommaviy oferta — sotuvchi va xaridor o'rtasidagi shartnoma matni.",
                "Qaytarish va almashtirish shartlari: muddat, tartib, kim yetkazib berish xarajatini ko'taradi.",
                "Yetkazib berish qoidalari: hududlar, muddat, tarif, minimal buyurtma summasi.",
                "Shaxsiy ma'lumotlar siyosati va ularni qayta ishlashga rozilik.",
                "Har bir tovar kartochkasida aniq narx, o'lchov birligi va mavjudlik holati.",
            ],
        },
        {
            type: "p",
            text:
                "Eng ko'p uchraydigan kamchilik — rekvizitlarning yo'qligi. Saytda faqat telefon raqami turadi, tashkilot nomi esa yo'q. Bu xaridor uchun ham, to'lov provayderi uchun ham salbiy signal.",
        },
        { type: "image", image: 1 },
        {
            type: "p",
            text:
                "Ikkinchi o'rindagi kamchilik — sahifalar bor, lekin ularga havola yo'q. Oferta manzili faqat to'g'ridan-to'g'ri kiritilganda ochiladi, saytdan esa topib bo'lmaydi. Tekshiruvda bu sahifa yo'q deb hisoblanadi. Barcha huquqiy sahifalarga futerda doimiy havola qoldiring.",
        },

        { type: "h2", text: "Ommaviy oferta: nega tayyor shablon yetarli emas?" },
        {
            type: "p",
            text:
                "Oferta — bu xaridor tugmani bosgan payt tuziladigan shartnoma. Internetdan olingan shablon ko'pincha boshqa biznes modeli uchun yozilgan bo'ladi va nizo chiqqanda sizga qarshi ishlaydi.",
        },
        {
            type: "p",
            text:
                "Kamida uchta band sizning haqiqiy jarayoningizga moslanishi kerak: buyurtma qachon qabul qilingan hisoblanadi, yetkazib berish muddati qanday hisoblanadi va qaysi holatlarda buyurtma bekor qilinadi. Shablonda bu bandlar umumiy yozilgan bo'ladi.",
        },
        {
            type: "p",
            text:
                "Biz loyihalarda oferta va qaytarish sahifalarini struktura sifatida beramiz — bo'limlar, sarlavhalar, to'ldirish kerak bo'lgan joylar. Matnning yuridik mazmunini esa mijozning yuristi yakunlaydi. Bu ikki ish aralashtirilsa, ikkalasi ham yomon bajariladi.",
        },

        { type: "h2", text: "Qaytarish qoidalari qanday yoziladi?" },
        {
            type: "p",
            text:
                "Masofadan savdoda xaridor tovarni ko'rmasdan sotib oladi — shu sababli qaytarish huquqi oddiy do'kondagidan kengroq. Saytda buni yashirish emas, aniq yozish foydali.",
        },
        {
            type: "ol",
            items: [
                "Qaytarish muddatini aniq kunlarda ko'rsating va u qaysi paytdan boshlanishini yozing.",
                "Qaytarilmaydigan toifalarni alohida sanab o'ting — bu nizolarning katta qismini oldini oladi.",
                "Tovar qanday holatda qabul qilinishini yozing: yorliq, qadoq, to'liq komplekt.",
                "Pulni qaytarish muddati va usulini ko'rsating. Karta bilan to'langan bo'lsa, pul o'sha kartaga qaytadi.",
                "Yetkazib berish xarajatini kim ko'tarishini aniq belgilang — bu eng ko'p bahs chiqadigan band.",
            ],
        },
        {
            type: "p",
            text:
                "Ochiq yozilgan qaytarish sahifasi konversiyani tushirmaydi, aksincha ko'taradi. Xaridor xavfni kam deb baholaganida birinchi buyurtmani osonroq beradi.",
        },

        { type: "h2", text: "Chek, ESF va markirovka: 2026-yil sanalari" },
        {
            type: "p",
            text:
                "Bu qism eng ko'p savol tug'diradi, chunki sanalar yaqin. Quyidagi jadval 2026-yilda kuchga kiradigan asosiy talablarni jamlaydi.",
        },
        {
            type: "table",
            head: ["Sana", "Nima o'zgaradi", "Kimga tegishli"],
            rows: [
                [
                    "2026-yil 1-yanvar",
                    "Markirovka buzilishlari bo'yicha tekshiruvlar masofadan, soliq organlari axborot tizimi orqali o'tkaziladi",
                    "Markirovka qilinadigan tovar sotuvchilari",
                ],
                [
                    "2026-yil 1-iyun",
                    "Kofe, sikoriy va ularning ekstraktlari majburiy raqamli markirovkaga kiritiladi",
                    "Oziq-ovqat savdosi",
                ],
                [
                    "2026-yil 1-iyul",
                    "Markirovka qilingan tovar sotilganda markirovka kodi onlayn-KKM chekida majburiy aks etadi",
                    "Chakana savdo, shu jumladan onlayn",
                ],
                [
                    "2026-yil 1-iyul",
                    "Markirovka qilinadigan mahsulot bo'yicha ulgurji savdoda hisob-kitob faqat naqdsiz, bank hisob raqamlari orqali",
                    "Ulgurji savdo",
                ],
                [
                    "2026-yil 1-sentyabr",
                    "Markirovka qoidalarini buzish «yuqori» soliq riski omili hisoblanadi",
                    "Barcha markirovka subyektlari",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Elektron hisob-faktura esa allaqachon majburiy va 2026-yilda uning avtomatik nazorati kuchaytirildi. Amalda bu shuni anglatadi: buyurtma, chek va ESF o'rtasidagi nomuvofiqlik endi tezroq ko'rinadi. Shuning uchun do'kon tizimini buxgalteriya bilan boshidan bog'lash kerak.",
        },
        {
            type: "p",
            text:
                "Soliq tomonida ham yangilik bor: 2026-yil 26-maydagi PF-100 farmoni bilan 1-iyundan umumiy soliq tizimiga o'tish chegarasi 1 mlrd so'mdan 12 000 BHM — taxminan 5 mlrd so'mgacha ko'tarildi. O'sayotgan do'konlar uchun bu QQS'ga o'tish nuqtasini sezilarli uzoqlashtiradi.",
        },

        { type: "h2", text: "Bu qanchaga tushadi?" },
        {
            type: "p",
            text:
                "Talablarni bajarish narxi ikki holatda juda farq qiladi: saytni qurayotganda kiritish yoki ishlayotgan saytga keyin qo'shish.",
        },
        {
            type: "table",
            head: ["Blok", "Loyiha boshida", "Keyin qo'shilganda"],
            rows: [
                ["Oferta, qaytarish, siyosat sahifalari", "Standart sahifa shabloni, kontent bilan to'ldiriladi", "Sahifa strukturasi va navigatsiya qayta ishlanadi"],
                ["Futerdagi rekvizitlar", "Layoutga birdan kiritiladi", "Barcha shablonlar bo'ylab tahrir"],
                ["Rozilik olish va jurnal yuritish", "Forma mantig'ining bir qismi", "Formalarni va bazani qayta ishlash"],
                ["Chek va ESF bilan bog'lash", "Buyurtma oqimiga kiritiladi", "Buyurtma mantig'ini qayta yozish"],
                ["Markirovka kodini yuritish", "Tovar kartochkasi maydoni sifatida", "Katalog strukturasini o'zgartirish"],
            ],
        },
        {
            type: "p",
            text:
                "Amaliyotimizda keyin qo'shish odatda ikki-uch barobar qimmatroq tushadi. Sababi oddiy: alohida sahifa yozish arzon, lekin ishlayotgan buyurtma oqimini o'zgartirish test va ma'lumotlar migratsiyasini talab qiladi.",
        },
        {
            type: "p",
            text:
                "Innobek'da ishlaydigan internet-do'kon 16 000 000 so'mdan boshlanadi va yuqoridagi bloklarning sayt tomoni shu narxga kiradi. Narxga kirmaydi: yuridik matnlarning o'zi, reyestr va soliq bo'yicha maslahat, buxgalteriya dasturi litsenziyalari.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Qilmaslik narxi nimadan iborat?" },
        {
            type: "p",
            text:
                "Bu yerda biz jarima summalarini yozmaymiz — ular tez o'zgaradi va tasdiqlanmagan raqamni keltirish foydadan ko'ra zarar keltiradi. Lekin bevosita biznes yo'qotishlarini sanash mumkin.",
        },
        {
            type: "list",
            items: [
                "To'lov tizimi arizasi rad etiladi. Oferta va qaytarish sahifalari yo'q sayt tekshiruvdan o'tmaydi.",
                "Marketpleysga chiqish kechikadi. Platformalar ham sotuvchidan hujjat va sayt shartlarini so'raydi.",
                "Nizolar sizga qarshi hal bo'ladi. Yozilmagan shart — mavjud bo'lmagan shart.",
                "Korporativ mijozlar ketadi. B2B xaridor rekvizitsiz saytdan buyurtma bermaydi.",
                "Soliq riski oshadi: markirovka qoidalarini buzish 2026-yil 1-sentyabrdan «yuqori» risk omili hisoblanadi.",
            ],
        },

        { type: "h2", text: "Qachon shoshilmaslik mumkin?" },
        {
            type: "p",
            text:
                "Hamma talab hamma biznesga bir xil tegishli emas. Quyidagi holatlarda ro'yxatning bir qismi sizga hozircha kerak emas.",
        },
        {
            type: "list",
            items: [
                "Savdo hali boshlanmagan, sayt katalog-vitrina sifatida ishlaydi va buyurtma qabul qilmaydi.",
                "Faqat B2B savdo qilasiz va har bir bitim alohida shartnoma bilan rasmiylashtiriladi.",
                "Markirovka qilinadigan toifalar bilan ishlamaysiz — u holda markirovka sanalari sizga tegishli emas.",
                "Do'kon test rejimida, oyiga bir necha buyurtma bilan gipoteza tekshirilmoqda.",
            ],
        },
        {
            type: "p",
            text:
                "Qolgan hollarda tekshiruv ro'yxatini bir marta bosib chiqish arzonroq. Bu bir kunlik ish, keyin qayta ishlash esa haftalar oladi.",
        },
        {
            type: "p",
            text:
                "Tartib esa quyidagicha bo'ladi. Avval biznes rasmiylashtirilgan va faoliyat turi to'g'ri ekanini tekshiring. Keyin saytdagi beshta majburiy sahifani tayyorlang va futerga havolalarni qo'ying. So'ng reyestr va to'lov tizimi arizalarini bir vaqtda bering. Oxirida chek, ESF va markirovka oqimini buxgalteringiz bilan kelishib, birinchi buyurtmada to'liq sinab ko'ring.",
        },
    ],

    faq: [
        {
            q: "Elektron tijorat subyektlari reyestriga kim kirishi kerak?",
            a: "2026-yil 10-fevralda Qonunchilik palatasi qabul qilib, 18-mayda Senat ma'qullagan qonunga ko'ra elektron tijorat subyektlari Reyestrda ro'yxatdan o'tishi shart. Bu onlayn savdo qiluvchi tashkilotlar va tadbirkorlarga tegishli. Ariza berish uchun biznes rasmiylashtirilgan, faoliyat turi savdoga mos va sayt ishlayotgan bo'lishi kerak.",
        },
        {
            q: "Saytda qanday sahifalar majburiy?",
            a: "Kamida beshta: to'liq rekvizitlar bilan futer, ommaviy oferta, qaytarish va almashtirish shartlari, yetkazib berish qoidalari hamda shaxsiy ma'lumotlar siyosati. Bundan tashqari har bir tovar kartochkasida aniq narx, o'lchov birligi va mavjudlik holati ko'rsatilishi kerak. Bu sahifalarsiz to'lov tizimi arizangizni ham qaytarishi mumkin.",
        },
        {
            q: "Ommaviy ofertani internetdan olsam bo'ladimi?",
            a: "Shablonni asos sifatida olish mumkin, lekin uni o'zgartirmasdan qo'yish xavfli — u odatda boshqa biznes modeli uchun yozilgan bo'ladi. Kamida uch band sizning jarayoningizga moslanishi kerak: buyurtma qachon qabul qilingan hisoblanadi, yetkazib berish muddati qanday hisoblanadi va qaysi holatlarda buyurtma bekor qilinadi. Yakuniy matnni yuristingiz tasdiqlashi zarur.",
        },
        {
            q: "Markirovka kodi chekda qachondan majburiy bo'ladi?",
            a: "2026-yil 1-iyuldan markirovka qilingan tovar sotilganda markirovka kodi onlayn-KKM chekida majburiy aks etishi shart. Shu sanadan markirovka qilinadigan mahsulot bo'yicha ulgurji savdoda hisob-kitob faqat naqdsiz, bank hisob raqamlari orqali amalga oshiriladi. 1-sentyabrdan esa markirovka qoidalarini buzish «yuqori» soliq riski omili hisoblanadi. 1-iyundan kofe va sikoriy ham majburiy markirovkaga kiradi.",
        },
        {
            q: "Qaytarish sahifasi sotuvni kamaytirmaydimi?",
            a: "Amaliyotda aksincha bo'ladi. Masofadan savdoda xaridor tovarni ko'rmasdan sotib oladi va uning asosiy to'sig'i — xavf hissi. Aniq yozilgan qaytarish shartlari bu xavfni pasaytiradi, ayniqsa notanish sotuvchiga beriladigan birinchi buyurtmada. Yashirilgan yoki umuman yo'q shartlar esa savatni tashlab ketishga va keyinchalik nizolarga olib keladi.",
        },
        {
            q: "Bu talablarni keyinroq qo'shsam bo'ladimi?",
            a: "Bo'ladi, lekin sezilarli qimmatroq tushadi. Alohida sahifa yozish arzon, ammo ishlayotgan buyurtma oqimini, formalarni va katalog strukturasini o'zgartirish test hamda ma'lumotlar migratsiyasini talab qiladi. Amaliyotimizda keyin qo'shish odatda ikki-uch barobar qimmat bo'ladi. Shuning uchun bu bloklarni texnik topshiriqqa loyiha boshidanoq kiriting.",
        },
    ],

    cta: {
        h: "Saytingizni tekshiruv ro'yxati bo'yicha ko'rib chiqamiz",
        p: "Sayt manzilingizni yuboring — qaysi bloklar yetishmayotganini va ularni qo'shish qancha ish talab qilishini bepul aytib beramiz.",
        button: "Tekshiruvni so'rash",
    },

    images: [
        {
            src: "/assets/img/blog/ecom-steps.webp",
            alt: "Internet-do'kon ochish bosqichlari — hujjat va texnik tayyorgarlik",
            caption: "Hujjat va texnika parallel ketganda ishga tushish sezilarli tezlashadi",
        },
        {
            src: "/assets/img/blog/ecom-legal-blocks.webp",
            alt: "Internet-do'kon saytida qonun talab qiladigan bloklar xaritasi",
            caption: "Saytdagi majburiy bloklar: rekvizitlar, oferta, qaytarish va siyosat",
            prompt:
                "Website anatomy diagram: a browser window wireframe with callout markers pointing to legally required blocks — company details in footer, public offer link, privacy policy, return policy page, contact and delivery terms; clean flat wireframe, blue callout pins, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/ecom-registry.webp",
            alt: "Elektron tijorat subyektlari reyestriga kirish bosqichlari",
            caption: "Reyestr arizasini to'lov tizimi arizasi bilan bir vaqtda tayyorlang",
            prompt:
                "Flow illustration of the registry process: business application -> notification to authority -> entry in e-commerce subjects registry -> public listing; four horizontal steps with document icons, minimal line style, blue accents, no text placeholders, 16:9",
        },
        {
            src: "/assets/img/projects/sbm-food.webp",
            alt: "SBM Food onlayn savdo sahifasi — mahsulot va yetkazib berish shartlari",
            caption: "SBM Food — yetkazib berish shartlari aniq joylashtirilgan sahifa",
        },
    ],

    relatedServices: ["internet-dokonlar", "veb-ilovalar", "texnik-qollab-quvvatlash"],
    relatedPosts: ["marketpleys-yoki-oz-internet-dokon", "onlayn-tolov-ulash-payme-click", "internetdokon"],
};

const ru = {
    meta: {
        title: "Требования закона к интернет-магазину 2026: чек-лист",
        description:
            "Реестр субъектов электронной коммерции, публичная оферта, правила возврата, чек и ЭСФ. Что требуется от интернет-магазина в 2026 году и сколько это стоит.",
        keywords: [
            "требования к интернет-магазину Узбекистан закон",
            "реестр субъектов электронной коммерции",
            "публичная оферта интернет-магазина",
            "возврат товара интернет-магазин Узбекистан",
            "закон об электронной коммерции",
        ],
    },
    h1: "Интернет-магазин 2026: чек-лист по реестру, оферте и правилам возврата",
    lead:
        "Время «сделал сайт и торгую» закончилось. В 2026 году онлайн-торговля предполагает регистрацию, конкретные страницы на сайте и новые требования к чеку. Ниже — чек-лист и его стоимость.",
    category: "Электронная коммерция",
    readingTime: "9 минут",

    body: [
        {
            type: "p",
            text:
                "Эта статья — не юридическое заключение. Мы строим сайты и показываем, какие блоки нужно закладывать в проект с самого начала. Финальные тексты должен утвердить ваш юрист — об этом мы говорим в начале каждого проекта.",
        },

        { type: "h2", text: "Что изменилось в 2026 году?" },
        {
            type: "p",
            text:
                "Законопроект о совершенствовании электронной торговли принят Законодательной палатой 10 февраля 2026 года и одобрен Сенатом 18 мая. Главное нововведение: субъекты электронной коммерции обязаны регистрироваться в Реестре субъектов электронной торговли.",
        },
        {
            type: "p",
            text:
                "Решение не случайное. Число электронных торговых платформ за год выросло с 36 до 115 — в 3,2 раза. Чем крупнее рынок, тем системнее контроль: государство хочет видеть, кто и чем торгует.",
        },
        {
            type: "p",
            text:
                "Базовая норма при этом остаётся прежней — закон «Об электронной коммерции». Согласно ему онлайн-продавец должен быть юридическим лицом, индивидуальным предпринимателем или самозанятым. Изменения 2026 года это требование не отменяют, а добавляют к нему обязанность зарегистрироваться в реестре.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Что означает включение в реестр?" },
        {
            type: "p",
            text:
                "Реестр — официальный перечень субъектов, занимающихся электронной торговлей. Регистрация в нём — разовое административное действие, но на ваш сайт оно влияет напрямую.",
        },
        {
            type: "list",
            items: [
                "Для подачи заявления бизнес уже должен быть оформлен: свидетельство о регистрации, ИНН, банковский счёт.",
                "Вид деятельности должен соответствовать торговле. Несоответствие останавливает и другие процессы.",
                "Сайт должен работать и быть заполненным — с пустыми страницами заявление не подают.",
                "При изменении данных (адрес, реквизиты, домен) их нужно своевременно обновлять.",
                "Сведения в реестре открыты — покупатель может вас проверить, и это дополнительный сигнал доверия.",
            ],
        },
        {
            type: "p",
            text:
                "Практический совет: готовьте заявление в реестр одновременно с заявкой в платёжную систему. Комплект документов для обеих процедур почти совпадает, а собирать их по отдельности означает потратить вдвое больше времени.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Какие блоки должны быть на сайте?" },
        {
            type: "p",
            text:
                "Проверьте свой сайт по списку ниже прямо сейчас. Каждый пункт — это отдельная страница или явно видимый блок. Вариант «расскажем, если спросят» здесь не работает.",
        },
        {
            type: "list",
            items: [
                "Полные реквизиты: название организации, ИНН, юридический адрес, телефон и электронная почта. Обычно размещаются в футере.",
                "Публичная оферта — текст договора между продавцом и покупателем.",
                "Условия возврата и обмена: срок, порядок, кто несёт расходы на доставку.",
                "Правила доставки: регионы, сроки, тарифы, минимальная сумма заказа.",
                "Политика обработки персональных данных и согласие на их обработку.",
                "В карточке каждого товара — точная цена, единица измерения и статус наличия.",
            ],
        },
        {
            type: "p",
            text:
                "Самый частый пробел — отсутствие реквизитов. На сайте стоит только номер телефона, а названия организации нет. Это негативный сигнал и для покупателя, и для платёжного провайдера при рассмотрении заявки.",
        },
        { type: "image", image: 1 },
        {
            type: "p",
            text:
                "Второй по частоте пробел — страницы есть, но ссылок на них нет. Оферта открывается только по прямому адресу, а с сайта её не найти. При проверке такая страница считается отсутствующей. Разместите постоянные ссылки на все правовые страницы в футере.",
        },

        { type: "h2", text: "Публичная оферта: почему шаблона недостаточно?" },
        {
            type: "p",
            text:
                "Оферта — это договор, который заключается в момент нажатия кнопки. Шаблон из интернета обычно написан под другую бизнес-модель и в случае спора работает против вас.",
        },
        {
            type: "p",
            text:
                "Как минимум три пункта нужно привести в соответствие с вашим реальным процессом: когда заказ считается принятым, как считается срок доставки и в каких случаях заказ отменяется. В шаблоне эти пункты сформулированы обобщённо.",
        },
        {
            type: "p",
            text:
                "В проектах мы отдаём страницы оферты и возврата как структуру — разделы, заголовки, места под заполнение. Юридическую часть текста доводит до конца юрист клиента. Если смешать эти две работы, обе будут выполнены плохо.",
        },

        { type: "h2", text: "Как написать правила возврата?" },
        {
            type: "p",
            text:
                "При дистанционной торговле покупатель приобретает товар, не видя его, поэтому право на возврат шире, чем в обычном магазине. Прятать это на сайте невыгодно — выгодно написать чётко.",
        },
        {
            type: "ol",
            items: [
                "Укажите срок возврата в конкретных днях и с какого момента он начинается.",
                "Отдельно перечислите категории, не подлежащие возврату, — это снимает большую часть споров.",
                "Опишите, в каком состоянии принимается товар: ярлыки, упаковка, полная комплектность.",
                "Укажите срок и способ возврата денег. При оплате картой средства возвращаются на ту же карту.",
                "Чётко определите, кто несёт расходы на доставку при возврате, — это самый спорный пункт.",
            ],
        },
        {
            type: "p",
            text:
                "Открыто написанная страница возврата не снижает конверсию, а повышает её. Когда покупатель оценивает риск как низкий, он легче оформляет первый заказ у незнакомого продавца.",
        },

        { type: "h2", text: "Чек, ЭСФ и маркировка: даты 2026 года" },
        {
            type: "p",
            text:
                "Этот блок вызывает больше всего вопросов, потому что сроки близкие. Таблица ниже собирает основные требования, вступающие в силу в 2026 году.",
        },
        {
            type: "table",
            head: ["Дата", "Что меняется", "Кого касается"],
            rows: [
                [
                    "1 января 2026",
                    "Проверки по нарушениям маркировки проводятся дистанционно, через информационную систему налоговых органов",
                    "Продавцы маркируемых товаров",
                ],
                [
                    "1 июня 2026",
                    "Кофе, цикорий и их экстракты включаются в обязательную цифровую маркировку",
                    "Продуктовая торговля",
                ],
                [
                    "1 июля 2026",
                    "Код маркировки обязательно отражается в чеке онлайн-ККМ при продаже маркированного товара",
                    "Розница, включая онлайн",
                ],
                [
                    "1 июля 2026",
                    "Расчёты в оптовой торговле маркируемой продукцией только безналично, через банковские счета",
                    "Оптовая торговля",
                ],
                [
                    "1 сентября 2026",
                    "Нарушение правил маркировки считается фактором «высокого» налогового риска",
                    "Все субъекты маркировки",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Электронный счёт-фактура уже обязателен, а в 2026 году автоматический контроль по нему усилен. На практике это значит, что расхождения между заказом, чеком и ЭСФ становятся заметны быстрее. Поэтому систему магазина связывают с бухгалтерией с самого начала.",
        },
        {
            type: "p",
            text:
                "Есть новость и на налоговой стороне: указом ПФ-100 от 26 мая 2026 года с 1 июня порог перехода на общий налоговый режим поднят с 1 млрд сум до 12 000 БРВ — это примерно 5 млрд сум. Для растущих магазинов точка перехода на НДС заметно отодвигается.",
        },

        { type: "h2", text: "Сколько это стоит?" },
        {
            type: "p",
            text:
                "Стоимость выполнения требований сильно различается в двух случаях: когда их закладывают при разработке сайта и когда добавляют к уже работающему магазину.",
        },
        {
            type: "table",
            head: ["Блок", "На старте проекта", "При добавлении позже"],
            rows: [
                ["Оферта, возврат, политика", "Стандартный шаблон страницы под заполнение", "Переработка структуры страниц и навигации"],
                ["Реквизиты в футере", "Закладываются в макет сразу", "Правка по всем шаблонам сайта"],
                ["Сбор согласий и ведение журнала", "Часть логики форм", "Переработка форм и базы данных"],
                ["Связка с чеком и ЭСФ", "Встроена в поток заказа", "Переписывание логики заказа"],
                ["Ведение кода маркировки", "Поле в карточке товара", "Изменение структуры каталога"],
            ],
        },
        {
            type: "p",
            text:
                "В нашей практике добавление позже обходится обычно в два-три раза дороже. Причина проста: написать отдельную страницу дёшево, а менять работающий поток заказов приходится с тестированием и миграцией данных.",
        },
        {
            type: "p",
            text:
                "В Innobek работающий интернет-магазин начинается от 16 000 000 сум, и сайтовая часть перечисленных блоков входит в эту цену. Не входят: сами юридические тексты, консультации по реестру и налогам, лицензии бухгалтерских программ.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Из чего складывается цена бездействия?" },
        {
            type: "p",
            text:
                "Суммы штрафов мы здесь не приводим — они быстро меняются, а публиковать неподтверждённую цифру вреднее, чем полезно. Зато прямые потери для бизнеса перечислить можно.",
        },
        {
            type: "list",
            items: [
                "Отказ платёжной системы. Сайт без оферты и условий возврата проверку не проходит.",
                "Задержка выхода на маркетплейс. Площадки тоже запрашивают у продавца документы и условия сайта.",
                "Споры решаются не в вашу пользу. Незафиксированное условие — это отсутствующее условие.",
                "Уход корпоративных клиентов. B2B-покупатель не оформит заказ на сайте без реквизитов.",
                "Рост налогового риска: с 1 сентября 2026 года нарушение правил маркировки считается фактором «высокого» риска.",
            ],
        },

        { type: "h2", text: "Когда можно не спешить?" },
        {
            type: "p",
            text:
                "Не все требования одинаково касаются каждого бизнеса. В перечисленных ниже ситуациях часть списка вам пока не нужна.",
        },
        {
            type: "list",
            items: [
                "Продажи ещё не начались, сайт работает как каталог-витрина и заказы не принимает.",
                "Вы торгуете только в B2B, и каждая сделка оформляется отдельным договором.",
                "Вы не работаете с маркируемыми категориями — тогда даты по маркировке вас не касаются.",
                "Магазин в тестовом режиме, проверяется гипотеза на нескольких заказах в месяц.",
            ],
        },
        {
            type: "p",
            text:
                "Во всех остальных случаях пройти чек-лист один раз дешевле. Это работа на один день, тогда как последующая переделка занимает недели.",
        },
    ],

    faq: [
        {
            q: "Кто должен войти в реестр субъектов электронной коммерции?",
            a: "Согласно закону, принятому Законодательной палатой 10 февраля 2026 года и одобренному Сенатом 18 мая, субъекты электронной коммерции обязаны регистрироваться в Реестре. Это касается организаций и предпринимателей, ведущих онлайн-торговлю. Для подачи заявления бизнес должен быть оформлен, вид деятельности — соответствовать торговле, а сайт должен работать.",
        },
        {
            q: "Какие страницы обязательны на сайте магазина?",
            a: "Минимум пять: футер с полными реквизитами, публичная оферта, условия возврата и обмена, правила доставки и политика обработки персональных данных. Дополнительно в карточке каждого товара должны быть указаны точная цена, единица измерения и статус наличия. Без этих страниц платёжная система может отклонить вашу заявку.",
        },
        {
            q: "Можно ли взять публичную оферту из интернета?",
            a: "Шаблон можно взять за основу, но размещать его без изменений рискованно. Как минимум три пункта нужно привести в соответствие с вашим процессом: когда заказ считается принятым, как считается срок доставки и в каких случаях заказ отменяется. Финальный текст обязательно должен утвердить ваш юрист.",
        },
        {
            q: "С какой даты код маркировки обязателен в чеке?",
            a: "С 1 июля 2026 года при продаже маркированного товара код маркировки обязательно отражается в чеке онлайн-ККМ. С той же даты расчёты в оптовой торговле маркируемой продукцией проводятся только безналично через банковские счета. А с 1 сентября 2026 года нарушение правил маркировки считается фактором «высокого» налогового риска.",
        },
        {
            q: "Не снизит ли страница возврата продажи?",
            a: "На практике происходит обратное. При дистанционной торговле покупатель берёт товар, не видя его, и главный барьер для него — ощущение риска. Чётко прописанные условия возврата этот риск снижают, особенно при первом заказе. Скрытые или отсутствующие условия, наоборот, ведут к брошенным корзинам и последующим спорам.",
        },
        {
            q: "Можно ли добавить эти требования позже?",
            a: "Можно, но дороже. Написать отдельную страницу недорого, однако менять работающий поток заказов, формы и структуру каталога приходится с тестированием и миграцией данных. В нашей практике добавление позже обходится обычно в два-три раза дороже. Поэтому закладывайте эти блоки в техническое задание сразу.",
        },
    ],

    cta: {
        h: "Проверим ваш сайт по чек-листу",
        p: "Пришлите адрес сайта — бесплатно скажем, каких блоков не хватает и какой объём работ потребуется, чтобы их добавить.",
        button: "Запросить проверку",
    },

    images: [
        {
            src: "/assets/img/blog/ecom-steps.webp",
            alt: "Этапы запуска интернет-магазина — документы и техническая подготовка",
            caption: "Когда документы и техника идут параллельно, запуск заметно ускоряется",
        },
        {
            src: "/assets/img/blog/ecom-legal-blocks.webp",
            alt: "Карта обязательных по закону блоков на сайте интернет-магазина",
            caption: "Обязательные блоки сайта: реквизиты, оферта, возврат и политика",
            prompt:
                "Website anatomy diagram: a browser window wireframe with callout markers pointing to legally required blocks — company details in footer, public offer link, privacy policy, return policy page, contact and delivery terms; clean flat wireframe, blue callout pins, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/ecom-registry.webp",
            alt: "Этапы включения в реестр субъектов электронной коммерции",
            caption: "Заявление в реестр готовьте одновременно с заявкой в платёжную систему",
            prompt:
                "Flow illustration of the registry process: business application -> notification to authority -> entry in e-commerce subjects registry -> public listing; four horizontal steps with document icons, minimal line style, blue accents, no text placeholders, 16:9",
        },
        {
            src: "/assets/img/projects/sbm-food.webp",
            alt: "Страница онлайн-продаж SBM Food — товар и условия доставки",
            caption: "SBM Food — страница, где условия доставки размещены на видном месте",
        },
    ],

    relatedServices: ["internet-dokonlar", "veb-ilovalar", "texnik-qollab-quvvatlash"],
    relatedPosts: ["marketpleys-yoki-oz-internet-dokon", "onlayn-tolov-ulash-payme-click", "internetdokon"],
};

const content = { uz, ru };

export default content;
